import ProfileNotifications from '@atoms/ProfileNotifications';
import { Divider, Text, View } from '@components/primitives';
import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ProfileSettingsProps = {
  showNotifications?: boolean;
};

function ProfileSettings({ showNotifications = false }: ProfileSettingsProps) {
  if (!showNotifications) return null;

  const { t } = useTranslation('common');

  return (
    <>
      <View style={[appStyles.marginLeft(16), { borderWidth: 0, overflow: 'hidden' }]} marginY="16px">
        <Text testID="txtProfileSettings" variant="md-bold">
          {t('profile.settings')}
        </Text>
        <ProfileNotifications showNotifications={showNotifications} />
      </View>
      <Divider height="4px" style={{ backgroundColor: colors.neutral.mist }} />
    </>
  );
}

export default ProfileSettings;
